import React from 'react';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import Layout from '../components/layout';
import Research from '../components/research';
import Sidebar from '../components/Sidebar';
import Welcome from './sections/welcome';
import WhatIsReadm from './sections/what-is-readm';
import WhoWeAre from './sections/who-we-are';
import WhoYouAre from './sections/who-you-are';
import Logo from './logo.svg';
import Banner from './Banner/Banner';

const IndexPage = ({ location }) => {
  return (
    <Layout>
      <div id="wrapper">
        <a href="https://readm.app">
          <img src={Logo} className="logo" />
        </a>
        <Banner />
      </div>
    </Layout>
  );
};

export default IndexPage;
